import React from "react";

import Modal from "components/Modals/Modal";
import ComponentError from "./ComponentError";
import styles from "./ModalError.module.scss";

interface Props {
    closeModal: () => void;
    errorMessage?: string;
}
const ModalError = ({ closeModal, errorMessage }: Props) => {
    return (
        <Modal
            classes={{
                container: styles["container"],
            }}
            isVisible
            onClickBackdrop={closeModal}
        >
            <ComponentError
                classes={{
                    root: styles["component-error"],
                }}
                errorMessage={errorMessage}
            />
        </Modal>
    );
};

export default ModalError;
